import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((_theme) => ({
  root: {
    minHeight: 300,
    paddingBottom: 50,
    position: 'relative',
  },
  toolbar: {
    marginBottom: 20,
  },
  title: {
    flexGrow: 1,
  },
}));

export default useStyles;
